<template>
  <div>
    <div class="sus">
      <div class="sus-i">
        <img src="../assets/img/success.png" alt="" />
      </div>
      <div class="sus-m">
        <p>支付成功</p>
      </div>

      <div class="countCircle">
        <span>{{ count }}秒后自动跳转</span>
      </div>
    </div>
    <button class="btn btn-gray" disable="disable" >返回</button>
  </div>
</template>
<script>
export default{
    data(){
        return {
            count:"3",//倒计时
        }
    },


 
mounted(){
   this.clickJump()
},
 
methods: {
  //几秒后进入跳转页面
    clickJump(){
        const timejump = 3;
        if(!this.timer){
            this.count = timejump ;
            this.show = false;
            this.timer = setInterval(()=>{
            if(this.count > 0 && this.count <= timejump ){
                this.count--;
            }else{
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                //跳转的页面写在此处
                this.$router.push({path: '/'});
            }
          },1000)
        }
    },
}
}
</script>

<style scoped>
.sus {
  width: 680px;
  height: 400px;
  background: #fff;
  margin: 200px auto;
}

.sus-i {
  width: 680px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sus-i img {
  width: 134px;
  height: 134px;
  /* margin: auto; */
}

.sus-m {
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #333333;
  font-size: 36px;
}

.sus-m p {
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 500;
}

.countCircle {
  height: 100px;
  text-align: center;
  line-height: 100px;  
}




</style>


// WEBPACK FOOTER //
// src/pages/success.vue